module.exports = __webpack_public_path__ + "static/img/roofed-interpretive-kiosk.c42d0a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/kiosks/roofed-interpretive-kiosk.jpg
// module id = 737
// module chunks = 0